"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCanisterDomain = void 0;
function getCanisterDomain(canisterId) {
    return `https://${canisterId}.raw.icp0.io`;
}
exports.getCanisterDomain = getCanisterDomain;
